import React from 'react';

const Testimonios = ({ testimoniosList }) => {
  // Verificamos de forma segura si la lista está vacía o es nula
  const tieneTestimonios = testimoniosList && testimoniosList.length > 0;

  return (
    <div className="space-y-10 animate-fadeIn text-slate-800">
      
      {/* 1. ENCABEZADO PRINCIPAL DE LA PESTAÑA */}
      <div className="text-center">
        <h3 className="text-2xl md:text-3xl font-black text-slate-900 tracking-tight">
          Lo que Dicen Nuestros Clientes
        </h3>
        <p className="text-slate-500 text-sm md:text-base mt-2 font-medium">
          Testimonios reales de estudiantes satisfechos con nuestros servicios
        </p>
      </div>

      {/* 2. CONTENEDOR DINÁMICO: GRILLA O ESTADO VACÍO */}
      {!tieneTestimonios ? (
        /* ESTADO VACÍO PREMIUM */
        <div className="bg-white border border-slate-200/60 rounded-[2rem] p-8 md:p-12 max-w-2xl mx-auto text-center space-y-4 shadow-sm">
          <div className="w-12 h-12 rounded-2xl bg-blue-50 text-blue-500 flex items-center justify-center mx-auto border border-blue-100 shadow-inner">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499c.172-.435.789-.435.961 0l1.566 3.965a.5.5 0 00.473.344l4.288.358c.47.039.658.621.314.93L15.93 11.96a.5.5 0 00-.144.444l.951 4.246c.104.464-.383.818-.797.575l-3.712-2.164a.5.5 0 00-.476 0l-3.712 2.164c-.414.243-.9-.111-.797-.575l.951-4.246a.5.5 0 00-.144-.444L2.831 10.1c-.344-.31-.155-.892.314-.93l4.288-.358a.5.5 0 00.473-.344l1.566-3.965z" />
            </svg>
          </div>
          <div className="space-y-1">
            <h4 className="font-black text-slate-800 text-sm md:text-base tracking-tight">
              Próximamente más testimonios
            </h4>
            <p className="text-slate-400 text-xs md:text-sm font-semibold max-w-md mx-auto leading-relaxed">
              Estamos procesando y anonimizando las últimas experiencias y calificaciones de nuestros estudiantes para cargarlas en este espacio.
            </p>
          </div>
        </div>
      ) : (
        /* GRILLA DE TESTIMONIOS ACTIVA */
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto mt-8">
          {testimoniosList.map((item, index) => (
            <div 
              key={index} 
              className="bg-white border border-slate-200/60 rounded-3xl p-6 md:p-8 shadow-sm flex flex-col justify-between gap-4 text-left hover:shadow-md transition-shadow"
            >
              {/* Fila Superior: Datos y Estrellas */}
              <div className="flex justify-between items-start gap-4">
                <div className="space-y-0.5">
                  <h4 className="font-black text-slate-800 text-base md:text-lg tracking-tight">
                    {item.name}
                  </h4>
                  <p className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                    {item.university}
                  </p>
                  <span className="text-xs md:text-sm font-bold text-blue-600 block pt-0.5">
                    {item.subject}
                  </span>
                </div>

                {/* Sistema de Estrellas SVG */}
                <div className="flex gap-0.5 text-amber-400 flex-shrink-0 pt-1">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                  ))}
                </div>
              </div>

              {/* Fila Inferior: Reseña */}
              <p className="text-slate-600 text-xs md:text-sm font-medium italic leading-relaxed border-t border-slate-50 pt-3">
                "{item.review}"
              </p>
            </div>
          ))}
        </div>
      )}

      {/* 3. BANNER VERDE DE LLAMADO A LA ACCIÓN (CTA) */}
      <div className="max-w-5xl mx-auto mt-12">
        <div className="bg-emerald-600 rounded-[2rem] p-8 md:p-12 text-white shadow-xl text-center space-y-6 relative overflow-hidden group">
          
          <div className="space-y-2 relative z-10">
            <h4 className="text-xl md:text-3xl font-black tracking-tight flex items-center justify-center gap-2">
              ¿Listo para tu Éxito Académico?
            </h4>
            <p className="text-emerald-100 text-xs md:text-base font-semibold opacity-90">
              Únete a los cientos de estudiantes que han confiado en nosotros
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 relative z-10 max-w-md mx-auto">
            <a 
              href="https://wa.me/573161585420" 
              target="_blank" 
              rel="noreferrer"
              className="w-full sm:w-auto bg-white hover:bg-slate-50 text-emerald-700 font-black text-xs md:text-sm px-8 py-3.5 rounded-xl transition-all shadow-md text-center"
            >
              Solicitar Servicio
            </a>
            
            <a 
              href="https://wa.me/573161585420?text=Hola,%20deseo%20consultar%20los%20precios." 
              target="_blank" 
              rel="noreferrer"
              className="w-full sm:w-auto bg-emerald-700 hover:bg-emerald-800 border border-emerald-500 text-white font-black text-xs md:text-sm px-8 py-3.5 rounded-xl transition-all text-center"
            >
              Consultar Precios
            </a>
          </div>

        </div>
      </div>

    </div>
  );
};

export default Testimonios;